import {
  createRecentVersionData,
  createSceneNode,
} from "@shared/common/utils/create";
import shortUUID from "short-uuid";
import type {
  CreateNodeOptions,
  ISectionGroupNode,
  PartialNode,
} from "../type";

const createSectionGroupNode = (
  data?: PartialNode<ISectionGroupNode>,
  options?: CreateNodeOptions
): ISectionGroupNode => {
  return {
    // 기본값
    id: shortUUID.generate(),
    pluginData: {
      contentEditorPropSeq: 0,
      contentMeta: [],
    },
    position: { type: "RELATIVE" },
    reactions: [],
    name: "",
    width: {
      value: 100,
      unit: "%",
    },
    padding: {
      top: {
        value: 15,
        unit: "px",
      },
      bottom: {
        value: 15,
        unit: "px",
      },
      left: {
        value: 15,
        unit: "px",
      },
      right: {
        value: 15,
        unit: "px",
      },
    },

    locked: false,
    visible: true,

    strokes: [],
    strokeWeight: 0,
    strokeAlign: "CENTER",
    strokeCap: "SQUARE",
    strokeJoin: "ROUND",
    dashPattern: [],

    fills: [],

    effects: [],
    alignHorizontal: "LEFT",

    layoutMode: "VERTICAL",
    primaryAxisSizingMode: "AUTO",
    counterAxisSizingMode: "AUTO",

    // 인자값
    ...createRecentVersionData(data),
    children:
      data?.children?.map((child) => createSceneNode(child, options)) ?? [],

    // 필수값
    type: "SECTION_GROUP",
  };
};

export default createSectionGroupNode;
